/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_LegalInputs */

const en_landing_footer_legal = /** @type {(inputs: Landing_Footer_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal`)
};

/**
* | output |
* | --- |
* | "Legal" |
*
* @param {Landing_Footer_LegalInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const landing_footer_legal = /** @type {((inputs?: Landing_Footer_LegalInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_LegalInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_footer_legal(inputs)
});
export { landing_footer_legal as "landing.footer.legal" }